import React from 'react';
import IOSInstallPrompt from './IOSInstallPrompt';
import AndroidInstallPrompt from './AndroidInstallPrompt';

/**
 * PWAInstallPrompt
 * 
 * iOS와 Android에서 각각 적절한 설치 안내를 표시하는 통합 컴포넌트
 * 
 * 사용법:
 * - App.js에 <PWAInstallPrompt /> 추가
 * - 자동으로 플랫폼 감지하여 적절한 프롬프트 표시
 */
function PWAInstallPrompt() {
  return (
    <>
      <IOSInstallPrompt />
      <AndroidInstallPrompt />
    </>
  );
}

export default PWAInstallPrompt;